// extracted by mini-css-extract-plugin
export var contrastLow = "_2j-1";
export var externalLink = "_2j-2";
export var externalLinkIcon = "_2j-3";
export var link = "_2j-0";
export var linkLabel = "_2j-4";